import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { mergeRegister } from '@lexical/utils';
import {
    BLUR_COMMAND,
    COMMAND_PRIORITY_CRITICAL,
    COMMAND_PRIORITY_LOW,
    FOCUS_COMMAND,
    INSERT_PARAGRAPH_COMMAND,
    KEY_ENTER_COMMAND,
} from 'lexical';

type SubmitKeyPluginProps = {
    onSubmit?: () => void;
};

function SubmitKeyPlugin({ onSubmit }: SubmitKeyPluginProps): null {
    const [editor] = useLexicalComposerContext();

    useLayoutEffect(() => {
        return mergeRegister(
            editor.registerCommand(
                KEY_ENTER_COMMAND,
                (event) => {
                    if (event !== null) {
                        event.preventDefault();
                        if (event.altKey) {
                            if (onSubmit) {
                                onSubmit();
                            }
                            return true;
                        }
                    }

                    return editor.dispatchCommand(INSERT_PARAGRAPH_COMMAND, undefined);
                },
                COMMAND_PRIORITY_CRITICAL
            )
        );
    }, [editor, onSubmit]);

    return null;
}

export default SubmitKeyPlugin;
